import React, { FC, useEffect, useState } from "react";
import { Chip, Grid, Stack, InputLabel } from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

interface ChipProps {
  label: string;
  variant?: "outlined" | "filled";
  isRounded?: boolean;
  onDelete?: () => void;
}

const BasicChips: FC<FormFieldProps> = (props) => {

  console.log("props",props);
  const classes = useStyles();
  const [selectedChips, setSelectedChips] = useState<string[]>([]);

  useEffect(() => {
    if (Array.isArray(props.selectedValues)) {
      setSelectedChips(props.selectedValues);
    } else {
      setSelectedChips([]);
    }
  }, [props.selectedValues]);

  const handleChipClick = (label: string) => {
    console.log("label",label);
    const isAlreadySelected = selectedChips.includes(mapLabel(label));

    let newSelectedChips: string[];
    if (isAlreadySelected) {
      newSelectedChips = selectedChips.filter((chip) => chip !== label);
    } else {
      newSelectedChips = [...selectedChips, label];
    }
    setSelectedChips(newSelectedChips);

    if (props.onChange) {
      if(newSelectedChips?.length){
        props.onChange({ target: { id: props.id, value: newSelectedChips } });
      } else {
        props.onChange({ target: { id: props.id, value: "" } });
      }
    }
  };

  useEffect(()=>{
    console.log("props.options",props.options);
    console.log("selectedChips",selectedChips);
  },[props.options,selectedChips])

  const mapLabel = (label: string) => {
    switch (label) {
      case "3 months":
        return "3M";
      case "5 days trial":
        return "5D";
        case "6 months":
        return "6M";
      case "12 months":
        return "12M";
      default:
        return label;
    }
  };

  const mapOrgLabel = (label: string) => {
    switch (label) {
      case "5D":
        return "5 days trial";
      case "3M":
        return "3 months";
        case "6M":
        return "6 months";
      case "12M":
        return "12 months";
      default:
        return label;
    }
  };

  const chips: ChipProps[] =
    props.options?.map((option) => ({
      label: mapLabel(option),
      variant: "outlined", // Default variant is "outlined"
      isRounded: props.isRounded,
      onDelete: props.onDelete,
    })) || [];

  const inputRender = () => (
    <Stack
      sx={{
        marginTop: '16px',
        marginBottom: '6px',
        paddingLeft: "6px",
        alignItems: 'center',
        display: 'flex',
        
      }}
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      useFlexGap
      flexWrap="wrap"
      spacing={0.5}
    >
      {chips.map((chip, index) => (
        <Chip
          size="small"
          key={index}
          label={mapOrgLabel(chip.label)}
          variant={selectedChips.includes(chip.label) ? "filled" : "outlined"}
          onClick={() => handleChipClick(chip.label)}
          onDelete={chip.onDelete}
          sx={{
            color: selectedChips.includes(chip.label) ? "#fff" : "#333",
            background: selectedChips.includes(chip.label) ? "#076C6B" : "transparent",
            borderRadius: chip.isRounded ? "50px" : "default",
            border: props.error ? "1px solid #d32f2f" : undefined,
            "&:hover": {
              background: selectedChips.includes(chip.label) ? "#076C6B" : "#f0f0f0",
              color: selectedChips.includes(chip.label) ? "#fff" : "#333",
             
            },
          }}
          // error={Boolean(props.error)}
        />
      ))}
    </Stack>
  );

  return (
    <>
      {props?.label ? (
        <>
          <Grid item xs={12} sm={5} mb={1} className={classes.labelBox}>
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {props?.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={7} style={{ padding: "0px" }}>
            {inputRender()}
          </Grid>
        </>
      ) : (
        inputRender()
      )}
    </>
  );
};

export default BasicChips;
